import { useTheme } from '@mui/material'
import { LuBrainCircuit } from 'react-icons/lu'
import SvgIcon from '@mui/material/SvgIcon'

interface Props extends React.SVGProps<SVGSVGElement> {
  plus?: boolean
  outline?: boolean
  offline?: boolean
  currentColor?: boolean
}

export default function IconLLM({ offline, currentColor, width, height }: Readonly<Props>) {
  const { palette } = useTheme()

  return (
    <SvgIcon
      component={LuBrainCircuit}
      width={width}
      height={height}
      style={{
        strokeWidth: 1.5,
        fill: 'none',
        stroke: currentColor ? 'currentColor' : offline ? palette.contrast.minimal : palette.node.main,
      }}
    />
  )
}
